'use client';
import React from 'react';
import { Anchor } from '@repo/ui/src/components/Anchor';
import Button from '@repo/ui/src/components/Button';
import { useCustomerOrders } from '@hooks/order';
import { LinkProps } from '@repo/ui/src/types/link';
import OrderRow from './DashboardOrderRow';
import LoadingLogo from '@components/Loading/LoadingLogo';
import { cTAClicked } from '@repo/ui/src/services/analytics';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';

interface Props {
  title?: string;
  emptyText?: string;
  shoppingLink?: LinkProps;
  orderText?: string;
  orderTotalText?: string;
  orderDateText?: string;
  orderDetailsLink: LinkProps;
  buttonText?: string;
  reviewText?: string;
  emptyLink?: LinkProps;
  quantityText?: string;
  giftCardLink: LinkProps;
}

const OrderHistory = ({
  orderText,
  orderTotalText,
  orderDateText,
  orderDetailsLink,
  emptyText,
  emptyLink,
  reviewText,
  title,
  quantityText,
  giftCardLink,
}: Props) => {
  const { data: orders, isLoading } = useCustomerOrders();
  const { locale } = useCurrentUrl();

  return (
    <>
      <div className="md:my-20">
        {!isLoading && (
          <div>
            {orders?.length ? (
              <ol className="w-full list-none pl-0" tabIndex={0}>
                {orders?.map(({ details }) => (
                  <OrderRow
                    {...details}
                    key={details?.orderNo}
                    order={orderText}
                    total={orderTotalText}
                    date={orderDateText}
                    orderDetailsLink={orderDetailsLink}
                    reviewLinkText={reviewText}
                    quantityText={quantityText}
                    giftCardLink={giftCardLink}
                    hideReviewLink
                  />
                ))}
              </ol>
            ) : (
              <>
                <p className="tra-text-web-body-l mb-5">{emptyText}</p>

                <Button
                  as={Anchor}
                  {...emptyLink}
                  size="small"
                  onClick={() => {
                    cTAClicked({
                      affiliation: 'website',
                      brand: 'Traeger',
                      locale,
                      cta_header: title,
                      cta_location: 'my account_order history',
                      cta_text: emptyLink?.displayName || '',
                      cta_type: 'button',
                      link_url: emptyLink?.link as any,
                    });
                  }}
                >
                  {emptyLink?.displayName}
                </Button>
              </>
            )}
          </div>
        )}
        {isLoading && <LoadingLogo />}
      </div>
    </>
  );
};

export default OrderHistory;
